import { DataObject } from '@shared/models/data-object.model';
import moment from 'moment';

const UTC_EDP_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';

/**
 * Return true if user has any active roles for companyId, else returns false
 * @param user
 * @param companyId
 */
export const isUserActive = (user: DataObject, companyId: number) => {
  let isActiveUser = false;
  if (user && user.company_role_addresses) {
    const selectedCompanyRoles = user.company_role_addresses.filter(
      companyRoleAddresses => companyRoleAddresses.company_id === companyId
    );
    if (selectedCompanyRoles && selectedCompanyRoles.length > 0) {
      const activeRoles = selectedCompanyRoles.filter(selectedCompanyRole => {
        const currentDt = moment(new Date(), UTC_EDP_INPUT_FORMAT).utc();
        const expiryDt = moment(selectedCompanyRole.expiry_date, UTC_EDP_INPUT_FORMAT).utc();
        return expiryDt.isAfter(currentDt);
      });
      isActiveUser = activeRoles && activeRoles.length > 0;
    }
  }
  return isActiveUser;
};
